
import { Modal, Button } from 'react-bootstrap';

const CancelEditModal = ({ show, onHide, onConfirm }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cancel Editing</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to cancel editing? All unsaved changes will be lost.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Continue Editing
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Cancel Editing
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelEditModal;